// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"4615": "760c9dbc","5005": "6301bb68","8021": "1997dc37","9405": "9a8ae760",}[chunkId] + ".css"
}